import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["customIdInput", "preview"];
  static values = {
    namespace: String,
    subdomain: String,
    customDomain: String,
  };

  connect() {
    this.update();
  }

  update() {
    if (!this.hasPreviewTarget) return;

    const hasCustomDomain =
      this.hasCustomDomainValue &&
      this.customDomainValue &&
      this.customDomainValue.trim() !== "";

    if (!this.hasCustomIdInputTarget || this.customIdInputTarget.disabled) {
      if (hasCustomDomain) {
        this.previewTarget.textContent = `${this.customDomainValue}/ep_[generated-id]`;
      } else {
        this.previewTarget.textContent =
          "listen.catchhook.app/hooks/ep_[generated-id]";
      }
      return;
    }

    const customId = this.customIdInputTarget.value || "[custom-id]";
    let url = "";

    if (hasCustomDomain) {
      url = `${this.customDomainValue}/${customId}`;
    } else {
      const hasValidSubdomain =
        this.hasSubdomainValue &&
        this.subdomainValue &&
        this.subdomainValue.trim() !== "";
      const hasValidNamespace =
        this.hasNamespaceValue &&
        this.namespaceValue &&
        this.namespaceValue.trim() !== "";

      if (hasValidSubdomain) {
        url = `${this.subdomainValue}.catchhook.app/hooks/${customId}`;
      } else if (hasValidNamespace) {
        url = `listen.catchhook.app/hooks/${this.namespaceValue}.${customId}`;
      } else {
        url = "listen.catchhook.app/hooks/ep_[generated-id]";
      }
    }

    this.previewTarget.textContent = url;
  }
}
